
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-services",
      function () {
        return require("private-next-pages/other-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-services"])
      });
    }
  